// globals: CcSwipeCatcher

/**
 * IDTech
 *
 * @constructor
 */
function IDTech() {

}

/**
 * Start enter i4go_p2peblock
 *
 * @param callback
 */
IDTech.prototype.start = function(bannerText, callback) {
    var catcher = new CcSwipeCatcher({
        bannerClass: 'cc-swipe-banner idtech-container',
        onComplete: function(isOk, obj) {
            if(isOk) {
                if (typeof callback.onComplete == 'function') {
                    callback.onComplete(obj.swipeBuffer);
                }
            }
        }.bind(this),
        onFinish: function(obj) {
            if (typeof callback.onCancel == 'function') {
                callback.onCancel(obj);
            }
        },
        bannerText: bannerText,
        cancelText: 'Cancel'
    });
    catcher._parseSwipe = function() {
        return true;
    };
    catcher.startSwipe();
};

window.IDTech = IDTech;
